module.exports = __webpack_public_path__ + "assets/img/openai.658c4ebd.png";